import React, {useState, useEffect} from 'react'
import {useSelector} from "react-redux";
import {getMicrosoftAnalysis} from "../api/client";
import {Customer, SeismicEmployee} from "./Utils";
import {Tag} from "@seismic/mantle";
import {CenteredSpinner} from "./CenteredSpinner";

const Sentence = (x) => {

    return <>
        <tr><td className="text-nowrap">{x.isCustomer ? <Customer/> : <SeismicEmployee />}&nbsp;{x.participantName}</td><td>{x.sentenceText}</td><td>{x.topics?.map(t=><Tag key={x.id + '_' + t} variant="info">{t}</Tag>)}</td></tr>
    </>
}

const Section = (props) => {

    const [show, setShow] = useState(false);
    
    return <div>
        <div style={{color: "blue", cursor: "pointer"}} onClick={()=> setShow(!show)}>{props.text}</div>
        {show && props.sentences != null && props.sentences.length > 0 ? <table>
            <tbody>
            {props.sentences.map(a=> <Sentence {...a}/>)}
            </tbody></table> : null}
    </div>
}

export const MicrosoftTab = () => {
    
    const [analysis, setAnalysis] = useState();
    const selectedMeetingId = useSelector(state => state.users.selectedMeetingId);

    const loadMicrosoftAnalysis = async () => {
        setAnalysis(null);
        let analysis = await getMicrosoftAnalysis(selectedMeetingId);
        setAnalysis(analysis);
    }
    
    useEffect(() => {
        if(selectedMeetingId != null) {
            loadMicrosoftAnalysis();
        }
    }, [selectedMeetingId]);

    if(selectedMeetingId == null)
        return <div>No meeting selected.</div>

    if(analysis == null)
        return <CenteredSpinner height="70vh" message="Loading (this takes up to 2 minutes to generate)..." />
    
    return <div>
        <div className="header">Chapters</div>
        <div className="meetingPanel" style={{height: "25vh", overflow: "auto"}}>
            {analysis.chapters.length === 0 && <div>No chapters found.</div>}
            {analysis.chapters.map(a=> <Section {...a} />)}
        </div>
        <div className="header">Narratives</div>
        <div className="meetingPanel" style={{height: "25vh", overflow: "auto"}}>
            {analysis.narratives.length === 0 && <div>No narratives found.</div>}
            {analysis.narratives.map(a=> <Section {...a} />)}
        </div>
        <div className="header">Issues And Resolutions</div>
        <div className="meetingPanel" style={{height: "20vh", overflow: "auto"}}>
            {analysis.issuesAndResolutions.length === 0 && <div>No issues and resolutions found.</div>}
            {analysis.issuesAndResolutions.map(a=> <Section {...a} />)}
        </div>
    </div>

};